export default "__VITE_ASSET__ec6a4aa2__"